"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerText = exports.BannerContainer = void 0;
const Typography_1 = __importDefault(require("../../UI/Typography"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.BannerContainer = styled_components_1.default.div `
  position: sticky;
  top: 0;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  padding: ${props => props.theme.spacing.s2}px;
  width: 100%;
  z-index: ${props => props.theme.attributes.zIndex.expressBanner};
  background-color: ${props => props.theme.palette.ORANGE_100};
`;
exports.BannerText = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s2}px;
  color: ${props => props.theme.palette.BW_100};
`;
exports.default = {
    BannerContainer: exports.BannerContainer
};
